import { BaseApiModel } from './BaseApiModel';

export class Samplings extends BaseApiModel {
  public acceptableQualityLevel: number;
  public minAmountViolations: number;
  public maxAmountViolations: number;
  public amountSampling: number;
}
